export const FEED_BACK_STATE = {
  COMPOSING: 'composing',
  FINISHED: 'finished'
}

export const UX = {
  NORMAL: 'normal',
  HARD: 'hard',
  EASY: 'easy'
}

export const ENV = {
  VUE_APP_ADDRESS: 'Số 5-7, Đường B4, Phường An Lợi Đông, TP. Thủ Đức, TP. Hồ Chí Minh',
  VUE_APP_HOTLINE: '1800 234 546',
  VUE_APP_OFFICE: '028 6279 8686',
  VUE_APP_FEEDBACK_HOTLINE: '1800 234 560',
  VUE_APP_SALES_EMAIL: 'sales@rever.vn',
  VUE_APP_SUPPORT: 'support@rever.vn',
  VUE_APP_PROJECT_EMAIL: 'phongduan@rever.vn',
  VUE_APP_ACADEMY_EMAIL: 'academy@rever.vn',
  VUE_APP_REVER_MST: '0313817128',
  VUE_APP_REVER_TECH_COMPANY_NAME: 'CÔNG TY CỔ PHẦN CÔNG NGHỆ REVER',
  VUE_APP_REVER_VN_ROOT_URL: 'https://rever.vn',
  VUE_APP_FORM_DESCRIPTION_NOTE: 'Đăng ký Rever Academy',
  VUE_APP_FORM_API: 'https://rever.vn',
  VUE_APP_REGISTER_SUCCESS_TITLE: 'Đăng ký thành công!',
  BASE_URL: '',
  VUE_APP_COURSE_CLASS:'Red16;Red32;BlueCX;Seller;Buyer;Red hire;SOI;Geo Farm;Transform;Win-win;Language for sales'
}
